import { Component, Input } from '@angular/core';
import { contractModificationsWizardSteps } from 'src/app/models/wizard-enum';

@Component({
  selector: 'contract-modification-preview',
  templateUrl: './request-preview.component.html',
  styleUrls: ['./request-preview.component.scss'],
  standalone: false,
})
export class RequestPreviewComponent {
  wizardStepsEnum = contractModificationsWizardSteps;

  @Input() contractModificationRequest: app.models.ContractModificationRequest;
  @Input() contractModificationRequestHeader: app.models.ContractModificationRequestHeader;
  @Input() DICTIONARY_CONTRACT_MODIFICATION_TYPE: app.models.DictionaryContractModificationRequestType;
  @Input() DICTIONARY_REIMBURSEMENT_TYPE: app.models.DictionaryReimbursementType;
  @Input() reasonOfRequest: string;
  @Input() purposeOfRequest: string;
  @Input() description: string;
  @Input() otherModificationType: string;
  @Input() editWizardStepHandler: any;
  @Input() nextStepHandler: any;
  @Input() deleteFileHandler: any;
  @Input() uploadFilesHandler: any;
}
